// extracted by mini-css-extract-plugin
module.exports = {"SpeicalOffers":"SpeicalOffers_SpeicalOffers__2jML8","ContentArea":"SpeicalOffers_ContentArea__1NqB1"};